import { cloneDeep, get } from "lodash-es";

export default {
  watch: {
    $route(newRoute, oldRoute) {
      if (newRoute.path !== oldRoute.path) {
        // set route on changed vuex store
        // used on axios error
        this.$store.dispatch("app/setRouteOnChanged", true);

        // reset page title
        this.$store.dispatch("app/setPageInfo", {
          pageTitle: "",
        });

        // close snackbar
        if (this.$store.getters["app/getSnackbar"].doNotClose !== true) {
          this.$store.dispatch("app/toggleSnackBar", {
            isTriggerClose: true,
          });
        } else {
          // delete doNotClose field
          const snackbarPayload = this.$store.getters["app/getSnackbar"];
          if (
            get(snackbarPayload, "message", null) !== null &&
            !get(snackbarPayload, "message", "").includes("Please sign-in back")
          ) {
            delete snackbarPayload.doNotClose;
            this.$store.dispatch("app/toggleSnackBar", {
              ...snackbarPayload,
            });
          }
        }

        // reset routeViewKey path & iteration
        this.routeViewKey.path = this.localePath(
          get(this, "$route.fullPath", ""),
        );
        this.routeViewKey.iteration = 0;

        // destroy - build window onResize
        window.removeEventListener("resize", this.windowOnResize);
        window.addEventListener("resize", this.windowOnResize);

        this.windowOnResize();
      }
    },

    sidebarMenuPersist: {
      deep: false,
      handler(newSidebarMenuPersist) {
        if (newSidebarMenuPersist !== "") {
          this.myMenu = cloneDeep(this.defineVisibility());
        }
      },
    },

    getRouteViewKey(newRouteViewKey) {
      // trigger 'reload' page
      if (newRouteViewKey.trigger) {
        const { iteration } = this.routeViewKey;
        this.routeViewKey.iteration = iteration + 1;
      }
    },
  },
};
